import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const ContactSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().trim().toLowerCase().email().max(254),
  subject: z.string().trim().max(200).optional().or(z.literal("")),
  message: z.string().trim().min(5).max(5000),
  locale: z.enum(["ar", "en"]).optional(),
  // Honeypot — must be empty
  website: z.string().max(0).optional().or(z.literal("")),
  // Minimum time spent on the form (ms) — bots submit instantly
  elapsedMs: z.number().int().nonnegative(),
});

export const submitContactMessage = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => ContactSchema.parse(data))
  .handler(async ({ data }) => {
    // Spam guards
    if (data.website && data.website.length > 0) {
      // Pretend success so bots don't probe
      return { ok: true };
    }
    if (data.elapsedMs < 1500) {
      return { ok: true };
    }

    const { error } = await supabaseAdmin.from("contact_messages").insert({
      name: data.name,
      email: data.email,
      subject: data.subject || null,
      message: data.message,
      locale: data.locale ?? null,
    });

    if (error) {
      console.error("contact_messages insert failed", error);
      throw new Error("Could not submit your message. Please try again.");
    }

    return { ok: true };
  });
